/**
 * @generated SignedSource<<130ce1f13988478bf721b920d0176cff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ExportToDocs_DocsConnectedQuery$variables = {};
export type ExportToDocs_DocsConnectedQuery$data = {
  readonly viewer: {
    readonly googleDocsConnected: boolean | null;
  };
};
export type ExportToDocs_DocsConnectedQuery = {
  response: ExportToDocs_DocsConnectedQuery$data;
  variables: ExportToDocs_DocsConnectedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "googleDocsConnected",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ExportToDocs_DocsConnectedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ExportToDocs_DocsConnectedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c5bb2ece60b7fa5802540169f2e353a5",
    "id": null,
    "metadata": {},
    "name": "ExportToDocs_DocsConnectedQuery",
    "operationKind": "query",
    "text": "query ExportToDocs_DocsConnectedQuery {\n  viewer {\n    googleDocsConnected\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "80e4cc8604a0acfd3713286ee85dd82f";

export default node;
